/* src/app/umbrella-common/copy-button/copy-button.style.scss */
.copy-button-wrapper {
  display: flex;
  flex-direction: column;
}
.copy-button-wrapper .notification {
  font-family: Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #d7273d;
  color: #585858;
  margin-top: 0.2rem;
}
.copy-button-wrapper .notification.visible {
  opacity: 1;
  transition: opacity 0.2s;
}
.copy-button-wrapper .notification:not(.visible) {
  opacity: 0;
  transition: opacity 1s;
}
.copy-button-wrapper button.copy-button {
  font-size: 12px !important;
  font-family: Arial, sans-serif;
  width: fit-content;
  height: 32px;
  padding: 0 8px 0 8px !important;
}
.copy-button-wrapper button.copy-button nb-icon {
  color: #ffffff;
  font-size: 16px;
  margin-right: 8px;
}
.copy-button-wrapper button.copy-button span {
  vertical-align: middle;
}
/*# sourceMappingURL=copy-button.style.css.map */
